module.exports = __webpack_public_path__ + "assets/img/ic-intro-vip.76e22237.png";